import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { useGetLocationData } from "~/hooks/locationData";
import { useDeleteCatalogMutation } from "~/schemas/generated/graphql";
import { useNotify } from "~/shared/hooks/useNotify";
import { ConfirmModal } from "~/shared/ui/ConfirmModal";

interface CatalogModal {
  isOpen: boolean;
  handleCloseModal: () => void;
  reFetchTable?: (id?: string) => void;
}

export const DeleteCatalogModal = (props: CatalogModal) => {
  const params = useParams<{ id: string }>();
  const { id } = params;
  const { isOpen, handleCloseModal, reFetchTable } = props;
  const { t } = useTranslation();
  const { currentId } = useGetLocationData();
  const { notifySuccess, notifyError } = useNotify();

  const onCompleted = () => {
    notifySuccess(t("documentLib.notification.removeSuccess"));
    handleCloseModal();
    setTimeout(() => reFetchTable(id), 0);
  };

  const onError = (e) => {
    notifyError(e?.message);
  };

  const [removeCatalog] = useDeleteCatalogMutation({
    onCompleted,
    onError,
  });
  const removeHandle = () => removeCatalog({ variables: { id: currentId } });

  return (
    <ConfirmModal
      open={isOpen}
      text={t("documentLib.catalogRemove")}
      onConfirm={removeHandle}
      onCancel={handleCloseModal}
      centered
      destroyOnHidden
    />
  );
};
